import type { GroundData } from '@/app/_components/ground/load-ground-data'
import type { ComposeStandInput } from '@/journey/_lib/compose-stand'

// Beat 06: the dashboard stand after Lesson 1, as a guest sees it. The
// next action is Quiz, which a guest cannot reach, so guestSignoff swaps
// the sign-off for "Sign in to keep your place →" — the product's own
// words (guest-mode spec §4, landing spec §4).
export function standInputForGuest(
    data: Pick<GroundData, 'lesson' | 'one' | 'today'>
): ComposeStandInput {
    return {
        today: new Date(data.today),
        nextAction: { lessonNumber: 1, path: 'quiz' },
        // Learn introduces without rating (no FSRS state yet), so all
        // fifteen are `introduced`; the two counts are disjoint.
        kanjiTouched: 0,
        kanjiIntroduced: 15,
        totalRealKanji: 2200,
        lesson: data.lesson,
        anchor: { character: data.one.character, meaning: data.one.meaning },
        restoration: null,
        reviewsDue: 0,
        reviewsFresh: 0,
        frontierLessonNumber: 1,
    }
}
